import { Pagination } from 'api/interfaces';
import { get, post, put, del } from 'api/methods';
import { ParametroTipoResultado } from 'helpers/enums/Parametros';

export interface ParametrosCooperativa extends Record<string, any> {
  bloqAlteraVoto: boolean;
  codCooperativa: string;
  configTexto: boolean;
  idParametroCoop: number;
  nomeCooperativa: string;
  ocultarNomeChat: boolean;
  texto: string;
  tipoResultado: ParametroTipoResultado;
  urlVideo: string;
}

export interface ParametrosTexto {
  idParametro: number;
  texto: string;
  urlVideo: string;
}

export type ParametrosCoopResponse = Pagination<ParametrosCooperativa>;

export interface ParametroCoopRequest extends Record<string, any> {
  bloqAlteraVoto: boolean;
  configTexto: boolean;
  idParametro: number;
  ocultarNomeChat: boolean;
  tipoResultado: ParametroTipoResultado;
}

export interface ParametrosCoop {
  codCooperativa: string;
  nomeCooperativa: string;
}

export interface AdicionarRespostaPadrao {
  codigoCooperativa: string;
  assunto: string;
  mensagem: string;
}

export interface EditarRespostaPadrao {
  id: number;
  assunto: string;
  mensagem: string;
}

export interface PublicRequest {
  idParametro: number;
  publico: boolean;
}
export interface ParamRequest {
  coodCooperativa?: any;
}

export type CooperativasParametrosResponse = Array<ParametrosCoop>;

const parametros = {
  cooperativas: () => {
    return get<CooperativasParametrosResponse>(
      'assembleiasAssessor',
      'parametro/filtro'
    );
  },
  listar: (size: number, page: number) => {
    return get<ParametrosCoopResponse>('assembleiasAssessor', 'parametro/', {
      params: { size, page },
    });
  },
  adicionar: (coodCooperativa: string) => {
    return post('assembleiasAssessor', 'parametro/', undefined, {
      params: { coodCooperativa },
    });
  },
  alterar: (data: ParametroCoopRequest) => {
    return put('assembleiasAssessor', 'parametro/', data);
  },
  alterarConfigTexto: (data: ParametrosTexto) => {
    return put('assembleiasAssessor', 'parametro/config-texto', data);
  },
  remover: (idParametroCoop: number) => {
    return del('assembleiasAssessor', `parametro/${idParametroCoop}`);
  },
  respostaPadrao: (codCoop: number) => {
    return get('assembleiasAssessor', `resposta-padrao/${codCoop}`);
  },
  listarRespostaPadrao: (codCoop: number) => {
    return get('assembleiasAssessor', `resposta-padrao/${codCoop}`);
  },
  adicionarRespostaPadrao: (data: AdicionarRespostaPadrao) => {
    return post('assembleiasAssessor', `resposta-padrao/`, data);
  },
  alterarRespostaPadrao: (data: EditarRespostaPadrao) => {
    return put('assembleiasAssessor', `resposta-padrao/`, data);
  },
  removerRespostaPadrao: (codCoop: number) => {
    return del('assembleiasAssessor', `resposta-padrao/${codCoop}`);
  },
  isPublic: (data: PublicRequest) => {
    return put(
      'assembleiasAssessor',
      'parametro/config-mensagem-publica',
      data
    );
  },
};

export default parametros;
